<template>
    <div>
      <div class="top">
        <div>
            <img
              src="@/assets/personal/work/back.png"
              class="top-left-img"
              @click="back"
          />
        </div>
        <div>
          <img
            src="@/assets/work/baoxiao.png"
            class="top-midlle-img"
          />
        </div>
  
        <div class="top-midlle-span">报销记录</div>
      </div>
      <div class="middle">
        <el-table
            ref="table"
            v-loading="searchLoading"
            :data="pageProps.records"
            element-loading-text="正在查询"
            fit
            stripe
            highlight-current-row
            
          >
              
          <el-table-column prop="title" label="职位" >
          </el-table-column>

          <el-table-column prop="type" label="类型" >
          <template slot-scope="{row}">
              <!--1病假2婚假3事假4丧假-->
              <span v-if="row.type==7">办公费</span>
              <span v-if="row.type==8">差旅费</span>
           </template>
        </el-table-column>
         
          <el-table-column prop="created_at" label="提交时间">
          </el-table-column>
          <el-table-column prop="min_time" label="报销时间" width="200">
            <template slot-scope="{row}">
                  <span>{{ formatDateTime(row.refund_time*1000)}}</span>
             </template>
          </el-table-column>
          <el-table-column prop="money" label="金额" > </el-table-column>
          <el-table-column prop="mark" label="事由" >
          </el-table-column>
          <el-table-column prop="status" label="状态" >
              <template slot-scope="{row}">
                  <span v-if="row.status==1">待审核</span>
                  <span v-if="row.status==2">审核通过</span>
                  <span v-if="row.status==3">驳回</span>
                </template>
          </el-table-column>
  
          <el-table-column label="操作" fixed="right" align="center" class-name="small-padding " >
              <template slot-scope="{row}">
              
                <el-button  type="primary" size="mini" @click="detail(row.id)">
                  详情
                </el-button>
              </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="text-align:center;padding:20px">
        <!--分页-->
        <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageProps.total"
            :page-size="pageProps.pageSize"
            :page-sizes="[5, 10, 50, 100]"
            :current-page="pageProps.pageNum"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
      </div>
      <info-dialog ref="infoDialogRef" @refresh="fetchData"></info-dialog>

    </div>
  </template>
  <script>
  import { leaveUserList } from "@/api/personal/work/approval/index";
  import infoDialog from "@/views/personal/work/approval/approval-info-dialog.vue";

  export default {
    components: { infoDialog},

    data() {
      return {
  
        searchLoading: false,
          pageProps: {
            records:[],
            total: 0,
            pageSize: 10,
            pageNum: 1
          },
  
          searchFormData:{
            job_id:"",	
            link:"3",
            name:"",
            page:0,
            limit:0
          },
       
      };
    },
  
    mounted() {
        this.fetchData();
      },
  
    methods: {
  
      fetchData(){
          var that = this;
          that.searchFormData.page=that.pageProps.pageNum;
          that.searchFormData.limit=that.pageProps.pageSize;
  
          leaveUserList(that.searchFormData).then((response) => {
            console.log(response);
            if(response.code==200){
              that.pageProps.records = response.data.data;
              that.pageProps.total = response.data.total;
            }else{
              that.$message.error(response.msg?response.msg:"请求错误");
            }
           
          });
        },
  
         // 当前页变更
        handleCurrentChange(num) {
          this.pageProps.pageNum = num
          this.fetchData()
        },
  
  
        // 每页显示页面数变更
        handleSizeChange(size) {
          this.pageProps.pageSize = size
          this.fetchData()
        },
  
        back() {
          this.$router.go(-1);
        },
  
        detail(id){
        this.$refs.infoDialogRef.init(id);

      },
        formatDateTime(value) { // 时间戳转换日期格式方法
          if (value == null) {
            return ''
          } else {
            const date = new Date(value)
            const y = date.getFullYear() // 年
            let MM = date.getMonth() + 1 // 月
            MM = MM < 10 ? ('0' + MM) : MM
            let d = date.getDate() // 日
            d = d < 10 ? ('0' + d) : d
            let h = date.getHours() // 时
            h = h < 10 ? ('0' + h) : h
            let m = date.getMinutes()// 分
            m = m < 10 ? ('0' + m) : m
            let s = date.getSeconds()// 秒
            s = s < 10 ? ('0' + s) : s
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
            }
        }
    },
  
  
  
  };
  </script>
  
  <style lang="scss" scoped>
  .top {
    width: 950px;
    height: 31px;
    display: flex;
  }
  .top-left-img {
    margin-top: 8px;
    width: 25px;
    height: 25px;
  }
  .top-midlle-img {
    width: 40px;
    height: 40px;
  }
  .top-midlle-span {
    margin-left: 20px;
    margin-top: 8px;
    height: 16px;
    font-size: 16px;
    color: #181818;
    font-weight: bold;
  }
  .top-right {
    margin-top: 2px;
    margin-left: 740px;
  }
  .middle {
    width: 847px;
    margin-top: 50px;
    margin-left: 30px;
  }
  .middle-list {
    color: #4d71d9;
  }
  .bottom {
    float: right;
  }
  </style>
  